import Button from "components/formElements/Button/Button";
import ForbiddenImage from "images/403.png";
import { useNavigate } from "react-router-dom";
import Page from "components/page/PageContent/PageContent";

import { routes } from "pages/routes";
import "./style.css";
import { useTranslation } from "react-i18next";

export const ForbiddenPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleDashboard = () => {
    navigate(routes.root.path());
  };

  const handleCatalog = () => {
    navigate(routes.libraryRoot.path());
  };

  return (
    <Page name="error">
      <div className="error-container">
        <div className="error-content-container">
          <div className="error-conatiner-right">
            <span className="error-heading">{t("ErrorPage.areSorry")}</span>
            <span className="error-title">{t("ErrorPage.cannotAccess")}</span>
            <span className="error-description">{t("ErrorPage.toCataOrCheckout")}</span>
            <div className="error-button-container">
              <Button className={"btn btn-primary"} onClick={handleCatalog}>
                {t("ErrorPage.browseCata")}
              </Button>
              <Button className={"btn btn-text btn-secondary"} onClick={handleDashboard}>
                {t("ErrorPage.toDashboard")}
              </Button>
            </div>
          </div>
          <div className="error-conatiner-left">
            <img src={ForbiddenImage} alt="403" />
          </div>
        </div>
      </div>
    </Page>
  );
};
